/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { FaRegCopy } from "react-icons/fa";
import { toast } from "react-toastify";
import { useRecoilState } from "recoil";
import { updateUser } from "../../api/User";
import { UserAtom } from "../../atoms/UserAtom";
import { CenterCSS, notSelect } from "../../styles/general";
import EmailConfirmationConfig from "../Modal/container/EmailConfirmationEdit";
import { useModal } from "../Modal/Modal";
import StyledButton from "../StyledButton";
import Switch from "../Switch";

const SecondaryTitle = styled.div`
  color: #222222;
  font-weight: 600;
  font-size: 16px;
`;

const LinkDiv = styled.div`
  margin-top: 13px;
  display: flex;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 5px;
`;

const FormContent = styled.div`
  width: 100%;
  height: fit-content;

  padding: 0 24px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const CopyIconContainer = styled.div`
  cursor: pointer;
  padding: 13px;
  color: #fb972e;
  border-left: 1px solid #ccc;
  ${CenterCSS}
`;

const SpaceBetween = styled.div`
  width: 100%;
  min-height: 42px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 1140px) {
    grid-gap: 32px;
  }

  .styled-auto-complete-wrapper {
    width: fit-content;
  }

  .grid-wrapper {
    display: grid;
    grid-template-columns: 280px 1fr;
    grid-gap: 32px;

    &.center {
      align-items: center;
    }

    @media screen and (max-width: 1140px) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      grid-gap: 16px;
    }
  }

  .flex-column-wrapper {
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    grid-gap: 8px;
  }
`;

export default function SendConfirmationConfig() {
  const [user, setUser] = useRecoilState(UserAtom);
  const modal = useModal();

  async function handleToggle(vle: boolean) {
    const isUpdated = await updateUser({
      options: { ...user.options, sendEmailConfirmation: vle },
    });

    if (isUpdated)
      setUser((u) => ({
        ...u,
        options: { ...u?.options, sendEmailConfirmation: vle },
      }));
  }

  function handleClick() {
    modal.pushModal(<EmailConfirmationConfig />, "Email Confirmation");
  }

  return (
    <>
      <SpaceBetween>
        <div className="grid-wrapper">
          <SecondaryTitle>Email Confirmation</SecondaryTitle>
        </div>

        <Switch
          toggled={Boolean(user.options?.sendEmailConfirmation)}
          whenToggled={handleToggle}
        />
      </SpaceBetween>

      {user.options?.sendEmailConfirmation && (
        <SpaceBetween>
          <div className="grid-wrapper center">
            <SecondaryTitle>Email Confirmation URL</SecondaryTitle>

            <LinkDiv>
              <span
                css={css`
                  padding: 9px 15px;
                  background-color: #f7f7f7;
                  ${notSelect}
                  max-width: 350px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                `}
              >
                {user.options?.emailConfirmationLink
                  ? user.options?.emailConfirmationLink
                  : "https://app.berserkermail.com/confirmed"}
              </span>
              <CopyIconContainer
                onClick={() => {
                  navigator.clipboard.writeText(
                    user.options?.emailConfirmationLink
                      ? user.options?.emailConfirmationLink
                      : "https://app.berserkermail.com/confirmed"
                  );

                  //That's not explicit in the design, but I thought it was necessary for the UX
                  toast("URL successfully copied to the clipboard!", {
                    type: "success",
                  });
                }}
              >
                <FaRegCopy />
              </CopyIconContainer>
            </LinkDiv>
          </div>

          <StyledButton
            inverted
            css={css`
              width: 100px;
            `}
            onClick={handleClick}
          >
            Edit
          </StyledButton>
        </SpaceBetween>
      )}
    </>
  );
}
